import snackbarTemplate from '@/plugins/snackbar/SnackbarTemplate.vue'

const SNACKBAR_COLORS = {
  error: '#F15435',
  success: '#0A8533',
  primary: '#002040'
}

/* eslint-disable prefer-promise-reject-errors */
export default {
  install(Vue, { vuetify } = {}) {
    let SnackbarConstructor = Vue.extend(snackbarTemplate)
    let snackbarInstance = null
    Vue.prototype.$snackbar = config => {
      return new Promise((resolve, reject) => {
        if (snackbarInstance) return
        const props = {
          el: document.createElement('div'),
          vuetify,
          data() {
            return {
              message: config.message || 'Ocorreu um erro, tente novamente',
              snackbarColor: config.snackbarColor ? SNACKBAR_COLORS[config.snackbarColor] || config.snackbarColor : 'grey darken-1',
              timeout: config.timeout
            }
          },
          methods: {
            closeSnackbar() {
              if (snackbarInstance) snackbarInstance.open = false
              snackbarInstance = null
              resolve()
            }
          }
        }
        snackbarInstance = new SnackbarConstructor(props)
        snackbarInstance.open = true
        document.body.appendChild(snackbarInstance.$el)
      })
    }
  }
}
